import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild, ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Address, OpenQuoteRequestsItem } from '../dashboard/open-quote-requests-widget/quote-requests.types';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, Subject, takeUntil } from 'rxjs';
import { OpenQuoteRequestsWidgetService } from '../dashboard/open-quote-requests-widget/open-quote-requests-widget.service';
import { MatDivider } from '@angular/material/divider';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MainFuseDrawerService } from '../main-fuse-drawer/main-fuse-drawer.service';
import { TinyMCEModule } from '@sbd-doug-frontend/shared/lib/ui/tinymce/tinymce.module';
import { MatError, MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { RiderRequest } from './rider-request.type';
import { CIPXRiderRequestService } from './rider-request.service';
import { CathyService } from '../../services/cathy.service';
import { forceValidation } from '@sbd-doug-frontend/shared/lib/public-forms';
import { UserService } from '../../core/user/user.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { TasksetsService } from '../tasksets/tasksets.service';
import {
  CommonFormFooterComponent
} from '@sbd-doug-frontend/shared/lib/shared-components/common-form-footer/common-form-footer.component';
import { BondsListItem } from '../bonds/bonds-list/bonds-list.type';
import { QuoteRequestsListItem } from '../quote/requests-list/quote-request.type';
import {
  CIPXActionBarComponent,
  CIPXCancelButtonComponent, CIPXPrimaryButtonComponent,
  CIPXScrollableContentComponent,
} from '@sbd-doug-frontend/shared/lib/ui';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderRowDef, MatRow, MatRowDef, MatTable,
} from '@angular/material/table';
import { MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'sbd-account-portal-frontend-rider-request',
  standalone: true,
  imports: [CommonModule, MatDivider, ReactiveFormsModule, MatCheckbox, MatIcon, MatIconButton, MatButton, TinyMCEModule, MatLabel, MatInput, MatFormField, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatPrefix, MatError, CdkTextareaAutosize, CommonFormFooterComponent, CIPXScrollableContentComponent, CIPXActionBarComponent, CIPXCancelButtonComponent, CIPXPrimaryButtonComponent, MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderRow, MatHeaderRowDef, MatMenu, MatMenuItem, MatRow, MatRowDef, MatTable],
  templateUrl: './rider-request.component.html',
  styleUrl: './rider-request.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiderRequestComponent implements OnInit, OnDestroy{
  @Input() showHeader!: boolean;
  @Input()  currentOpenQR: OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem;
  @Output() moveBackEvent = new EventEmitter<boolean>();
  @Output() requestSubmitted = new EventEmitter<boolean>();

  @ViewChild('riderFormScroll', { static: false, read: ElementRef }) riderFormScroll!: ElementRef;

  _unsubscribeAll: Subject<void> = new Subject<void>();

  _fb = inject(FormBuilder);
  riderRequestForm: FormGroup;
  _changeDetector = inject(ChangeDetectorRef);
  _userService = inject(UserService);
  _riderRequestService = inject(CIPXRiderRequestService);
  _cathyService = inject(CathyService);


  enableSubmitButton = false;

  checkboxes = [
    { key: 'nameOnBond', fields: ['name_change'] },
    { key: 'addressOnBond', fields: ['address', 'change_type'] },
    { key: 'effectiveDateOnBond', fields: ['effective_date'] },
    { key: 'expirationDateOnBond', fields: ['expiration_date'] },
    { key: 'bondAmountOnBond', fields: ['amount'] },
    { key: 'otherChangesOnBond', fields: ['otherChanges'] },
  ];

  constructor() {
  }

  ngOnInit(){

    this.riderRequestForm = this._fb.group({
      nameOnBond: [false],
      name_change: [''],

      addressOnBond: [false],
      address: [''],
      change_type: [''],

      effectiveDateOnBond: [false],
      effective_date: [''],

      expirationDateOnBond: [false],
      expiration_date: [''],

      bondAmountOnBond: [false],
      amount: ['', [Validators.pattern('^[0-9]+$')]],

      otherChangesOnBond: [false],
      otherChanges: [''],

      customer_notes: [''],
    });

    this.appendValidatiors();
  }

  ngOnDestroy() {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  submitForm() {
    this.riderRequestForm.markAllAsTouched();
    forceValidation(this.riderRequestForm);
    this._changeDetector.detectChanges();

    if (this.riderRequestForm.invalid) {
      return;
    }

    if (this.riderRequestForm.valid) {
      const postData =<RiderRequest>{
        request_method: 'Dani Form',
        bond_rider_request: {
          order_number: this.currentOpenQR.order_number,
          name: this._userService.currentAccountUser().name ,
          email: this._userService.currentAccountUser().email,
          phone: this._userService.currentAccountUser().phone,
          principal_name: this.currentOpenQR.user_first_name + ' ' + this.currentOpenQR.user_last_name,
          bond_type: 'Bond', //TODO Ask Jason
        },
        bond_rider_changes: {
          principal_name: {
            name: this.riderRequestForm.get('name_change').value,
            change: this.riderRequestForm.get('nameOnBond').value,
          },

          address: {
            change: this.riderRequestForm.get('addressOnBond').value,
            address: this.riderRequestForm.get('address').value,
            change_type: this.riderRequestForm.get('change_type').value,
          },

          effective_date: {
            change: this.riderRequestForm.get('effectiveDateOnBond').value,
            effective_date: this.riderRequestForm.get('effective_date').value,
          },

          expiration_date: {
            change: this.riderRequestForm.get('expirationDateOnBond').value,
            expiration_date: this.riderRequestForm.get('expiration_date').value,
          },

          penalty: {
            change: this.riderRequestForm.get('bondAmountOnBond').value,
            amount: this.riderRequestForm.get('amount').value,
          },

          other: {
            change: this.riderRequestForm.get('otherChangesOnBond').value,
            changes: this.riderRequestForm.get('otherChanges').value,
          },
        },
        GetTotalCost: 0,
        bond_number: this.currentOpenQR.carrier_reference_number,
        bond_rider_customer_notes: this.riderRequestForm.get('customer_notes').value,
        bond_rider_fee_excuse: 'Volume Account',
        quote_request_id: this.currentOpenQR.quote_request_id,
        quote_request_bond_id: this.currentOpenQR.quote_request_bond.quote_request_bond_id,
        carrier_id: this.currentOpenQR.carrier_id,
        shipping_address_id: this.currentOpenQR.quote_request_bond.shipping_address_id,
        billing_address_id: this.currentOpenQR.quote_request_bond.billing_address_id,
      };

      this._riderRequestService.createRequest(postData).subscribe((response) => {
        if(response?.success){
          this.riderRequestForm.reset()
          this.requestSubmitted.emit(true);
          this._cathyService.success(response.message);
          return;
        }

        this._cathyService.error(response.message);

      });

    } else {
    }
  }

  public shouldEnableSubmitButton() {
    let count = 0;
    this.checkboxes.forEach(checkbox => {
      if (!this.riderRequestForm.get(checkbox.key).value) {
        count++;
      }
    });
    this.enableSubmitButton = count !== this.checkboxes.length;
  }

  private appendValidatiors() {
    this.checkboxes.forEach(checkbox => {
      this.riderRequestForm.get(checkbox.key).valueChanges.subscribe((checked: boolean) => {
        this.shouldEnableSubmitButton();
        const fields = checkbox.fields;
        fields.forEach(field => {
          const nameChangeControl = this.riderRequestForm.get(field);
          if (checked) {
            nameChangeControl.setValidators(Validators.required);
          } else {
            nameChangeControl.clearValidators();
          }
          nameChangeControl.updateValueAndValidity();
          this._changeDetector.detectChanges();
        });
      });
    });
  }

  onCancelEvent(){
    this.moveBackEvent.emit(true);
  }

  getFormattedAddress(address: Address): string {
    if (!address) return '';

    let formattedAddress = '';
    if (address.street_1) {
      formattedAddress += address.street_1;
    }
    if (address.street_2) {
      formattedAddress += ', ' + address.street_2;
    }
    if (address.city) {
      formattedAddress += formattedAddress ? ', ' + address.city : address.city;
    }
    if (address.state_abbreviation) {
      formattedAddress += formattedAddress ? ', ' + address.state_abbreviation : address.state_abbreviation;
    }
    if (address.zip) {
      formattedAddress += formattedAddress ? ' ' + address.zip : address.zip;
    }
    return formattedAddress;
  }
}
